<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4>Batalkan Pesanan</h4>
        <p>Apakah kamu yakin ingin membatalkan pesanan dengan
          nomor transaksi <b>{{d.orderNo}}</b>?</p>
        <div class="fieldGroup">
          <div class="fieldCnt">
            <label>Pilih Alasan Pembatalan</label>
            <select class="field" v-model="reason">
              <option>Ingin merubah pesanan</option>
              <option>Ingin merubah alamat pengiriman</option>
              <option>Ingin merubah kurir pengirim</option>
              <option>Ingin merubah metode pembayaran</option>
              <option>Alasan lainya</option>
            </select>
          </div>
        </div>
        <div class="modalAction">
          <button class="btn secondary" v-if="!loading" v-on:click="close(false)">Kembali</button>
          <button class="btn primary" :class="{loading: loading}"
            v-on:click="cancelOrder">
            <span>Batalkan Pesanan</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'cancelOrder',
  components: { Confirmation },
  data() {
    return {
      show: false,
      d: null,
      next: null,
      loading: false,
      reason: '',
      reasonCustom: '',
    };
  },
  methods: {
    open(d, next) {
      this.d = d;
      this.loading = false;
      this.next = next;
      this.reason = 'Ingin merubah pesanan';
      this.reasonCustom = '';
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    cancelOrder() {
      this.loading = true;
      this.$http.post(this.$config.uri(`user/purchase/${this.d.id}/cancel`), {
        reason: this.reason,
      }).then((r) => {
        if (r.data.status !== 200) {
          const msg = (r.data.message) ? r.data.message : 'Internal server error, please try again later';
          this.$refs.confirmDialog.open({
            title: 'Pembatalan Pesanan Gagal',
            desc: msg,
            action: 'Tutup',
            confirm: false,
          }, () => {
            this.close(false);
          });
        }
        this.close(true);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      max-width: 420px;
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 30px 30px;
      }
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #444;
        @media (max-width: 680px) {
          font-size: 20px;
        }
        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
      }
      p{
        margin: 0 0 20px;
        color: #767676;
        line-height: 1.4;
        @media (max-width: 680px) {
          font-size: 15px;
        }
      }
      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        @media (max-width: 680px) {
          margin: 30px -30px -30px;
        }
        .btn{
          margin-left: 10px;
          &.primary{
            background-color: red;
          }
        }
      }
    }
  }
</style>
